import { Checkbox } from '@/global/components/Checkbox'
import { Combobox } from '@/global/components/Combobox'
import React from 'react'
import { local } from 'service/api'
import { useStore } from 'store'
import { SelectProps } from './types'
import { deveExibirSelect } from './visibilidade'

interface IProps
    extends Omit<SelectProps, 'form' | 'isSupervisor' | 'defaultValue'> {
    children?: never
    value?: number[]
    onChange?: React.Dispatch<React.SetStateAction<number[]>>
    /** Não filtrar por empresa e sim por cliente */
    listAll?: boolean
}

export const SelectLocais: React.FC<IProps> = ({
    size = 'small',
    variant = 'filled',
    width = 260,
    hideWhenSingle = false,
    value: controlledValue,
    onChange: controlledOnChange,
    listAll = false,
    disabled,
    helperText,
    className,
}) => {
    const empresaId = useStore(state => state.companyId)
    const storeValue = useStore(state => state.locaisIds)
    const setStoreValue = useStore(state => state.setLocaisIds)

    const {
        data: filteredData = [],
        isFetched: isFilteredFetched,
        isFetching: isFilteredFetching,
    } = local.useFetch({
        queryParams: {
            empresaId,
        },
        enabled: !listAll,
    })
    const {
        data: allData = [],
        isFetched: isAllFetched,
        isFetching: isAllFetching,
    } = local.all.useFetch({
        enabled: listAll,
    })
    const data = listAll ? allData : filteredData,
        isFetched = listAll ? isAllFetched : isFilteredFetched

    if (!deveExibirSelect(data.length, hideWhenSingle, isFetched)) {
        return null
    }

    const value = controlledValue ?? storeValue,
        onChange = controlledOnChange ?? setStoreValue,
        isFetching = listAll ? isAllFetching : isFilteredFetching

    const nomePorId = new Map(data.map(it => [it.id, it.nomeLocal]))
    const opcoes = data.map(it => it.id)
    const todosMarcados = data.length > 0 && value.length === data.length

    return (
        <div style={{ width }} className={className}>
            <Combobox<number>
                label="Locais"
                multiple
                size={size}
                variant={variant === 'outlined' ? 'outlined' : 'filled'}
                placeholder="Selecione os locais"
                options={opcoes}
                value={value}
                onChange={onChange}
                getOptionLabel={id => nomePorId.get(id) ?? ''}
                getOptionKey={id => String(id)}
                isOptionEqualToValue={(option, valor) => option === valor}
                renderValue={ids =>
                    ids
                        .map(id => nomePorId.get(id))
                        .filter(Boolean)
                        .join(', ')
                }
                loading={isFetching}
                noOptionsText="Nenhum local cadastrado"
                helperText={helperText}
                disabled={disabled}
                footer={
                    data.length ? (
                        <Checkbox
                            label={
                                todosMarcados
                                    ? 'Desmarcar todos'
                                    : 'Selecionar todos'
                            }
                            checked={todosMarcados}
                            onCheckedChange={() =>
                                onChange(todosMarcados ? [] : opcoes)
                            }
                        />
                    ) : undefined
                }
            />
        </div>
    )
}
